// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DvrTile_wrapper__ZYXNF","title":"DvrTile_title__15ofo","time":"DvrTile_time__19h2U"};